import classNames from 'classnames'
import './dialog.scss'

export const DialogHeaderLayout = defineComponent({
  name: 'DialogHeaderLayout',
  inheritAttrs: false,
  setup(_props, { slots, attrs }) {
    return () => (
      <div {...attrs} class={classNames('dialog-header-layout', attrs.class as string)}>
        {slots.default?.()}
      </div>
    )
  },
})
